<!-- 律所认证 -->
<template>
    <div class="iframe-box">
        <iframe
            :src="bjhUrl"
            frameBorder="0"
            class="bjh-content"
        ></iframe>
    </div>
</template>

<script>
/**
 * @file 法律律所认证页面
 * @description 法律律所认证页面
 * @author dingzhenyue@baidu.com
 */
export default {
    naem: 'lawFirmAuthentication',
    data() {
        return {
            iframeHeight: 0,
            bjhUrl: ''
        };
    },
    mounted() {
        // 曝光打点
        this.$log && this.$log.send({
            type: 'show',
            value: 'law-firm-authentication',
            page: 'lawFirmAuthentication'
        });
        this.bjhUrl = 'https://baijiahao.baidu.com/builder/rc/settings/accountSet?pageSource=lvlin&header=0&aside=0&footer=0';
    },
    methods: {
    }
};
</script>

<style lang='less' scoped>
.bjh-content {
    width: 1206px;
    height: 100%;
}
.iframe-box {
    position: relative;
    left: 0;
    top: 0;
    width: 1206px;
    height: 100%;
}
</style>
